module.exports = __webpack_public_path__ + "img/menuIcon30.c8a7e99c.png";